import { render } from "./TypesFilterPage.vue?vue&type=template&id=767a7d85&scoped=true"
import script from "./TypesFilterPage.vue?vue&type=script&lang=js"
export * from "./TypesFilterPage.vue?vue&type=script&lang=js"

import "./TypesFilterPage.vue?vue&type=style&index=0&id=767a7d85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767a7d85"]])

export default __exports__